/* ---------------------------------------
---- Add users to the MailChimp List -----
--------------------------------------- */

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {

    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');

};

// target the forms
const craftForm = document.querySelector('[data-id="craft-submission"]')
const mailchimpForm = document.querySelector('[data-id="mailchimp-subscribe"]')
// handle the form function
const handleMailChimpForm = () => {

  // mailchimp inputs
  const mailchimpFirstName = mailchimpForm.querySelector('input[name="mcvars[FNAME]"]')
  const mailchimpLastName = mailchimpForm.querySelector('input[name="mcvars[LNAME]"]')
  const mailchimpEmail = mailchimpForm.querySelector('input.mailchimp-email')

  craftForm.addEventListener('submit', (e) => {
    e.preventDefault()

    const checkboxValue = craftForm.querySelector('#cf-email-checkbox').checked

    if (checkboxValue) {
      // find out if first name / last name fields exist
      const firstNameField = craftForm.querySelector('input[name="fields[firstName]"]')
      const lastNameField = craftForm.querySelector('input[name="fields[lastName]"]')
      // get email field
      const email = craftForm.querySelector('input[name="fields[emailAddress]"]')
      // check to see if the form uses a single full name field
      const fullName = craftForm.querySelector('input[name="fields[name]"]')
      // prepare the MailChimp separate name variables
      let firstName = ''
      let lastName = ''
      // split the name for MailChimp if fullName exists
      if (fullName) {
        // split the fullName
        const splitName = fullName.value.split(' ')
        firstName = splitName[0]
        // remove the first item and join any renaining names
        lastName = splitName.slice(1).join(' ')
        
      } else {
        firstName = firstNameField.value
        lastName = lastNameField.value
      }

      mailchimpFirstName.value = firstName
      mailchimpLastName.value = lastName
      mailchimpEmail.value = email.value

      // now lets "serialize" our form data, like AJAX does
      // https://craftcms.stackexchange.com/questions/33814/posting-to-plugins-action-controller-using-ajax-json
      // using the serialize helper: https://gomakethings.com/how-to-serialize-form-data-with-vanilla-js/
      const formData = serialize(mailchimpForm)
      // now lets send the form using XMLHttpRequest
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log("The MailChimp form was successful")
          craftForm.submit()
        } else {
          console.log("There was an unexpected failure")
          craftForm.submit()
        }
      }

      xhr.open("POST", "/", true)
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.setRequestHeader("Accept", "application/x-www-form-urlencoded")
      xhr.send(formData)

    } else {
      // the checkbox was not ticked, submit the form – without MailChimp
      craftForm.submit()
    }
  })
}

if (craftForm && mailchimpForm) {
  handleMailChimpForm()
}

// target the forms
// inline forms (not popup)
const inlineCraftForm = document.querySelector('[data-id="craft-submission"]')
const inlineMailchimpForm = document.querySelector('[data-id="mailchimp-subscribe"]')

// popup forms
const popupCraftForm = document.querySelector('[data-id="popup-craft-submission"]')
const popupMailchimpForm = document.querySelector('[data-id="popup-mailchimp-subcribe"]')

// mailchimp function
const handleMailchimpFormSubmission = (craftFormTag, mailchimpFormTag) => {

  // mailchimp inputs
  const mailchimpFirstName = mailchimpFormTag.querySelector('input[name="mcvars[FNAME]"]')
  const mailchimpLastName = mailchimpFormTag.querySelector('input[name="mcvars[LNAME]"]')
  const mailchimpEmail = mailchimpFormTag.querySelector('input.mailchimp-email')

  // handle the form on submit
  craftFormTag.addEventListener('submit', (e) => {

    // prevent the form submitting
    e.preventDefault()
    // check for marketing consent checkbox
    const checkboxValue = craftFormTag.querySelector('#cf-email-checkbox').checked

    // if the checkbox value is checked (marketing permission exists)
    if (checkboxValue) {
      // find out if first name / last name fields exist
      const firstNameField = craftFormTag.querySelector('input[name="fields[firstName]"]')
      const lastNameField = craftFormTag.querySelector('input[name="fields[lastName]"]')
      // get email field
      const email = craftFormTag.querySelector('input[name="fields[emailAddress]"]')
      // check to see if the form uses a single full name field
      const fullName = craftFormTag.querySelector('input[name="fields[name]"]')
      // prepare the MailChimp separate name variables
      let firstName = ''
      let lastName = ''
      // split the name for MailChimp if fullName exists
      if (fullName) {
        // split the fullName
        const splitName = fullName.value.split(' ')
        firstName = splitName[0]
        // remove the first item and join any renaining names
        lastName = splitName.slice(1).join(' ')
        
      } else {
        firstName = firstNameField.value
        lastName = lastNameField.value
      }

      mailchimpFirstName.value = firstName
      mailchimpLastName.value = lastName
      mailchimpEmail.value = email.value

      // now lets "serialize" our form data, like AJAX does
      // https://craftcms.stackexchange.com/questions/33814/posting-to-plugins-action-controller-using-ajax-json
      // using the serialize helper: https://gomakethings.com/how-to-serialize-form-data-with-vanilla-js/
      const formData = serialize(mailchimpFormTag)
      // now lets send the form using XMLHttpRequest
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log("The MailChimp form was successful")
          craftFormTag.submit()
        } else {
          console.log("There was an unexpected failure")
          craftFormTag.submit()
        }
      }

      xhr.open("POST", "/", true)
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.setRequestHeader("Accept", "application/x-www-form-urlencoded")
      xhr.send(formData)

    } else {
      // the checkbox was not ticked, submit the form – without MailChimp
      craftFormTag.submit()
    }
  })

}

// if an inline craft form exists with an inline mailchimp subscribe
// if (inlineCraftForm && inlineMailchimpForm) {
//   handleMailchimpFormSubmission(inlineCraftForm, inlineMailchimpForm)
// }

// if a popup craft exists with a popup mailchimp subscribe
// if (popupCraftForm && popupMailchimpForm) {
//   handleMailchimpFormSubmission(popupCraftForm, popupMailchimpForm)
// }